export const defaultLocale = "en-US";
export const defaultDateFormat = "MM/DD/YYYY";
export const altDateFormat = "MMM DD, YYYY";
export const defaultCurrency = "$";
